import draftGrades from '../data/draftGrades.json';
import predictionIssues from '../data/predictionIssues.json';

const latestForecast = predictionIssues.issues.find((issue) => issue.season === predictionIssues.latest.season && issue.week === predictionIssues.latest.week);

const gradeStandings = [...draftGrades.teams].sort((a, b) => a.rank - b.rank);
const ajDraft = draftGrades.teams.find((team) => team.manager === 'A.J.');
const robbyDraft = draftGrades.teams.find((team) => team.manager === 'Robby');
const robbyKeeper = robbyDraft.keeperVerdict[0];

export const CURRENT_SEASON = {
  year: 2026,
  leagueSeason: 14,
  phase: 'postDraft',
  issueVolume: 'VOL XIV',
  issueNumber: 'NO. 01',
  currentWeek: { year: 2026, week: 1 },
  scheduleReleased: true,
  keepersLocked: true,
  keeperDeadline: '2026-08-26T00:00:00-07:00',
  keeperDeadlineLabel: 'Wed Aug 26, 2026 at 12:00 AM PDT',
  draftAt: '2026-08-29T14:00:00-07:00',
  kickoff: {
    label: 'September 2026',
    monthLabel: 'SEPT 2026',
  },
  draftLabel: 'Sat Aug 29, 2026 at 2:00 PM PDT',
  keeperRule: {
    summary: 'Each manager may keep one player from last season.',
    cost: 'Keeping that player costs the 2026 draft pick from the round where he was drafted in 2025.',
  },
};

export const NAV_SPOTLIGHT = { to: '/ai-picks' };

export function isPreDraftSeason(season = CURRENT_SEASON) {
  return season.phase === 'preDraft';
}

export function hasPublishedSchedule(season = CURRENT_SEASON) {
  return season.scheduleReleased === true && season.currentWeek !== null;
}

export const DEFAULT_TICKER_MESSAGE = [
  `WEEK ${predictionIssues.latest.week} AI PICKS · FIVE MATCHUPS · THE MATH IS ON THE RECORD`,
  `${draftGrades.draftedPickCount} PICKS FILED · ${draftGrades.keeperCount} KEEPERS PRICED · ${draftGrades.teams.length} GRADES PUBLISHED`,
  gradeStandings.slice(0, 3).map((team) => `${team.manager.toUpperCase()} ${team.letter}`).join(' · '),
  `A.J. HOSTED · THE HOUSE WAS PERFECT · THE BENCH WAS ${ajDraft.benchQuality.toFixed(1)}`,
  `ROBBY KEPT ${robbyKeeper.player.toUpperCase()} IN ROUND ${robbyKeeper.round}`,
  `ALL ${draftGrades.teams.length} GRADES · WITH THE MATH`,
  `FORECAST FIRST KICKOFF · ${(latestForecast.firstKickoffLabel || 'SEE THE DATED ISSUE').toUpperCase()}`,
  'DATED PREDICTIONS · ORIGINAL PICKS PRESERVED',
  'THE TAPE REMAINS ON FILE · TEICH RANKED HIMSELF FIRST',
].join(' · ');
